import { Logger } from '@mobalytics/shared';
import { useCallback, useEffect, useState } from 'react';
import { useAppStore } from '../../store/app-store.hook';
import { DynamicModuleContextI } from './dynamic-modules.types';
import { initDynamicModules } from './dynamic-modules';
import { fetchCommonDynamicModulesConfig } from './dynamic-modules.utils';
import { DynamicModuleSlug } from './dynamic-modules.types';

interface UseFetchDynamicModulesResult {
  isLoaded: boolean;
  dynamicModulesData: DynamicModuleContextI | null;
}

export const useFetchDynamicModules = (): UseFetchDynamicModulesResult => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [dynamicModulesData, setDynamicModulesData] = useState<DynamicModuleContextI | null>(null);
  const { setGameRegistry } = useAppStore().configStore;

  const fetchDynamicModulesConfig = useCallback(async () => {
    try {
      const configMap = await fetchCommonDynamicModulesConfig();

      if (!configMap) {
        Logger.error('Invalid dynamic modules config response');
        return;
      }

      const modulesData = await initDynamicModules(configMap);

      // set before isLoaded: the app renders only after it, and payment pages need productAbbreviation right away
      setGameRegistry(modulesData[DynamicModuleSlug.GAME_REGISTRY]);
      setDynamicModulesData(modulesData);
    } catch (error) {
      Logger.error('Error fetching dynamic modules config:', error);
    } finally {
      setIsLoaded(true);
    }
  }, [setGameRegistry]);

  useEffect(() => {
    fetchDynamicModulesConfig();
  }, [fetchDynamicModulesConfig]);

  return { isLoaded, dynamicModulesData };
};
